import { Component, OnInit } from '@angular/core';
import { ErrorService } from '../../services/error.service';
import { Error } from '../../models/error.model';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  providers: [ErrorService]
})
export class ErrorPageComponent implements OnInit {
  public isServerError: boolean;
  public errorMessage: string;
  constructor(private errorService: ErrorService) {}

  ngOnInit() {
    this.isServerError = false;
    const error: Error = this.errorService.GetErrorData();

    switch (error.code) {
      case 400:
      case 404:
        this.errorMessage = 'The email link has expired.';
        break;
      case 500:
        this.isServerError = true;
        this.errorMessage = `Please try again later. Error Number ${error.id}`;
        break;
    }
  }
}
